export const formatDuration = (duration: number): string => {
  const seconds = Math.floor(duration / 1000);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const pad = (value: number): string | number => (value < 10 ? `0${value}` : value);
  return `${hours > 0 ? `${pad(hours)}:` : ''}${pad(minutes)}:${pad(remainingSeconds)}`;
};
